import type { TDocumentSlot } from '@/@types/company';
import type { Id } from '../../convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: standard convex _generated import
import type { TStartingSource } from '@/@types/insuranceBuilder';

const DOCUMENT_SLOTS: readonly TDocumentSlot[] = [
  'identityDocFront',
  'identityDocBack',
  'drivingLicenseFront',
  'drivingLicenseBack',
];

export function isDocumentSlot(val: string): val is TDocumentSlot {
  return (DOCUMENT_SLOTS as readonly string[]).includes(val);
}

export function isValidProviderId(value: string): value is Id<'insuranceProviders'> {
  return value.length > 0;
}

export function isValidOrgTypeId(value: string): value is Id<'orgInsuranceTypes'> {
  return value.length > 0;
}

export function isValidStartingSource(value: string): value is TStartingSource {
  return value === 'blank' || value === 'predefined' || value === 'copy' || value === 'ai';
}
